import {
	Collapse,
	createStyles,
	Grid,
	InputAdornment,
	TextField,
	Theme,
	withStyles,
	WithStyles,
} from '@material-ui/core'
import React from 'react'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'

interface StipendReceivedProps extends WithStyles<typeof styles> {
	stipendReceivedStringValue: string | null
	stipendAmount?: number | null
	onStipendAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onStipendReceivedChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const StipendReceived: React.FC<StipendReceivedProps> = (props: StipendReceivedProps) => {
	const { classes, onStipendAmountChange, onStipendReceivedChange, stipendAmount, stipendReceivedStringValue } = props
	const [open, setOpen] = React.useState(props.stipendReceivedStringValue === 'Yes')

	React.useEffect(() => {
		setOpen(stipendReceivedStringValue === 'Yes')
	}, [stipendReceivedStringValue])

	return (
		<div className={classes.root}>
			<OutcomeDropDownItem
				label="Stipend or Wage Received"
				prop="stipendReceived"
				value={stipendReceivedStringValue}
				onInputChange={onStipendReceivedChange}
				items={['Yes', 'No']}
			/>
			<Collapse in={open} style={{ transformOrigin: '0 0 0', flexGrow: 1 }} {...(open ? { timeout: 750 } : {})}>
				<Grid container={true} spacing={8}>
					<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
          Stipend or Wage amount&#58;
					</Grid>
					<Grid item={true} xs={12} sm={3}>
						<TextField
							name="stipendAmount"
							className={classes.dropdown}
							value={stipendAmount || ''}
							onChange={onStipendAmountChange}
							margin="dense"
							variant="outlined"
							InputProps={{
								startAdornment: <InputAdornment position="start">$</InputAdornment>,
								inputProps: {
									type: 'number',
									min: '0',
									step: '0.01'
								},
							}}
						/>
					</Grid>
				</Grid>
			</Collapse>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		dropdown: { display: 'flex', flex: 1 },
		dropdownLabel: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
	})

export default withStyles(styles)(StipendReceived)
